<script setup lang="ts">
import Avatar from 'primevue/avatar';
import { computed } from 'vue';

const props = defineProps<{
  nickname: string;
  avatar?: string | null;
  size?: 'normal' | 'large' | 'xlarge';
}>();

const label = computed(() => props.nickname.slice(0, 1).toUpperCase());
</script>

<template>
  <Avatar
    v-if="avatar"
    :image="avatar"
    shape="circle"
    :size="size ?? 'large'"
    class="user-avatar"
  />
  <Avatar
    v-else
    :label="label"
    shape="circle"
    :size="size ?? 'large'"
    class="user-avatar user-avatar--placeholder"
  />
</template>

<style scoped>
.user-avatar--placeholder :deep(.p-avatar-label) {
  background: linear-gradient(135deg, #fb7185, #f472b6);
  color: white;
  font-weight: 700;
}
</style>
